module.exports = __webpack_public_path__ + "static/media/rc2.54538a82.jpg";